import Status from "./status";

export default class DadosPessoais {
  constructor(id = '', nome='', nomeSocial='', cpf='', rg='', curso='', raca) {
    this.id = id;
    this.nome=nome;
    this.nomeSocial=nomeSocial;
    this.cpf=cpf;
    this.rg=rg;
    this.curso=curso;
    this.raca = new Status(raca);
  }
}
